import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import EmployeeDetailControl from '../Employee/EmployeeDetailControl.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const EmployeeVerificationControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;


	const { search } = useLocation();
		const searchparams = new URLSearchParams(search);
		const param = searchparams.get("id");


	// alert(param);

const [precheckup, setPreCheckup] = useState({
	emp_verifydate: "",
	pre_expiry_date: "",
	verify_by: "",
	bg_initdate:"",
	bg_compdate:"",
	bg_doneby:"",
	bg_remarks:"",
	vac_infodate:"",
	vac_expdate:"",
	vac_doneby:"",
	vac_remarks:"",


		
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setPreCheckup({ ...precheckup, [name]: value });

		
	}


	const [allemployeeval, setallemployeeval]= useState([]);

	const handleAllEmployee = async () => {

		axios.get(API_BASE_URL +'/showallemployee/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.user_det))
		.then(res1 => setallemployeeval(res1.data.user_det))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEmployee();
	  }, []);



	  const [data, setData] = useState([]);

	  useEffect(() => {
		axios.get(API_BASE_URL + '/fetchprecheck/'+ param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])



	useEffect(() => {
		axios.get(API_BASE_URL + '/showprecheck/'+ param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			 .then(res => setPreCheckup(res.data[0]))
			// .then(res => console.log(res.data[0]))
			.catch(err => console.log(err));
	}, [])



	const handleUpdatePrecheckupSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addprecheckup', { emp_verifydate: precheckup.emp_verifydate,pre_expiry_date:precheckup.pre_expiry_date,verify_by:precheckup.verify_by,verify_remark:precheckup.verify_remark,user_id:param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const handleUpdatebackgroundverificationSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addbackgroundverification', { bg_initdate: precheckup.bg_initdate,bg_compdate:precheckup.bg_compdate,bg_doneby:precheckup.bg_doneby,bg_remarks:precheckup.bg_remarks,user_id:param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};





	const handleUpdateVaccinationCommissionSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addvaccinationcommission', { vac_infodate: precheckup.vac_infodate,vac_expdate:precheckup.vac_expdate,vac_doneby:precheckup.vac_doneby,vac_remarks:precheckup.vac_remarks,user_id:param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	return (
		<>


<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3" style={{
                
                backgroundColor:
                    "#fff",
            }}>
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-stethoscope mr-2" style={{ fontSize: "20px" }} />
												Pre Employement Checkup
											</h3>
										</div>
										<div className="card-body">
                                        <form onSubmit={handleUpdatePrecheckupSubmit}> 
												<div class="row">
										
									<div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Verifiy Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="emp_verifydate" value={precheckup.emp_verifydate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Expiry Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="pre_expiry_date" value={precheckup.pre_expiry_date}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Verify By </label>

											<select className="form-control show-tick required-input required-tooltip" name="verify_by" value={precheckup.verify_by} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.user_id} value={option1.user_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Remarks</label>

										<textarea
										id="textarea"
										name="verify_remark"
										value={precheckup.verify_remark} // Bind the value to state
										onChange={handelInput} // Update state on change
										placeholder="Remarks"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Verifiy Date</th>
															<th>Expiry Date</th>
															<th>Verify By</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>



														{
															data.map((emp, index) => {

																return <tr key={index}>
																	
																	<td>
																		<span>{emp.emp_verifydate}</span>
																	</td>
																	<td>
																		<span>{emp.pre_expiry_date}</span>
																	</td>
																	<td>
																		<span>{emp.verify_by}</span>
																	</td>

																	<td>
																		<span>{emp.verify_remark}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>



										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-check-square-o mr-2" style={{ fontSize: "20px" }} />
												Background Verification
											</h3>
										</div>
										<div className="card-body">
                                        <form onSubmit={handleUpdatebackgroundverificationSubmit}> 
												<div class="row">
										
									<div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Background Initiation Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="bg_initdate" value={precheckup.bg_initdate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Background Complete Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="bg_compdate" value={precheckup.bg_compdate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Done By </label>

											<select className="form-control show-tick required-input required-tooltip" name="bg_doneby" value={precheckup.bg_doneby} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.user_id} value={option1.user_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Background Verification Remarks</label>

										<textarea
										id="textarea"
										name="bg_remarks"
										value={precheckup.bg_remarks} // Bind the value to state
										onChange={handelInput} // Update state on change
										placeholder="Remarks"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										


										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-medkit mr-2" style={{ fontSize: "20px" }} />
												Vaccination Commission Information
											</h3>
										</div>
										<div className="card-body">
                                        <form onSubmit={handleUpdateVaccinationCommissionSubmit}> 
												<div class="row">
										
									<div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Information Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="vac_infodate" value={precheckup.vac_infodate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
									<label className="form-label">Expiry Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="vac_expdate" value={precheckup.vac_expdate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-4 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Done By </label>

											<select className="form-control show-tick required-input required-tooltip" name="vac_doneby" value={precheckup.vac_doneby} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.user_id} value={option1.user_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Vaccination Remarks</label>

										<textarea
										id="textarea"
										name="vac_remarks"
										value={precheckup.vac_remarks} // Bind the value to state
										onChange={handelInput} // Update state on change
										placeholder="Remarks"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>



										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Information Date</th>
															<th>Expiry Date</th>
															<th>Done By</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>



														{
															data.map((emp, index) => {

																return <tr key={index}>
																	
																	<td>
																		<span>{emp.vac_infodate}</span>
																	</td>
																	<td>
																		<span>{emp.vac_expdate}</span>
																	</td>
																	<td>
																		<span>{emp.vac_doneby}</span>
																	</td>

																	<td>
																		<span>{emp.vac_remarks}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>







									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeVerificationControl);